import { useEffect, useMemo, useState } from "react";
import { Col, Container, Row, Card, Spinner, Alert } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Purchasemodal from "../../components/purchaseplan/purchasemodal";
import { useGetSubscriptionMarketingQuery } from "../../features/marketing/marketingApiSlice";

const PLAN_ORDER = ["Free", "Basic", "Standard", "Premium"];

/** Normalize any common API envelope into a plans array */
const extractPlans = (response) => {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.plans)) return response.plans;
  return [];
};

/** Only show features saved by admin for this plan */
const getPlanFeatures = (plan) => {
  return (plan?.features || [])
    .filter((f) => f && (f.title || f.description) && f.isActive !== false)
    .map((f) => ({
      title: f.title || f.description || "",
    }));
};

const formatPrice = (plan) => {
  const monthly = plan?.pricing?.monthly || {};
  const currency = monthly.currency || "PKR";
  const amount = Number(monthly.amount);
  if (!Number.isFinite(amount) || amount <= 0) {
    return { currency, amountLabel: "0", isFree: true };
  }
  return {
    currency,
    amountLabel: amount.toLocaleString(),
    isFree: false,
  };
};

const Subscriptionmdl = ({
  lgShow,
  setLgShow,
  setPurchase,
  purchase,
  id,
  getbusinesstype,
}) => {
  const [planselected, setPlanselected] = useState("");

  const {
    data: subscriptionResponse,
    isLoading,
    isFetching,
    isError,
    refetch,
  } = useGetSubscriptionMarketingQuery(undefined, {
    // Always allow a fresh read when the modal opens
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (lgShow) {
      refetch();
    }
  }, [lgShow, refetch]);

  const paymentplan = useMemo(() => {
    const plans = extractPlans(subscriptionResponse);
    return [...plans]
      .filter((plan) => plan && plan.status !== "inactive")
      .sort((a, b) => {
        const ai = PLAN_ORDER.indexOf(a?.planName);
        const bi = PLAN_ORDER.indexOf(b?.planName);
        const aRank = ai === -1 ? PLAN_ORDER.length : ai;
        const bRank = bi === -1 ? PLAN_ORDER.length : bi;
        return aRank - bRank;
      });
  }, [subscriptionResponse]);

  const loading = isLoading || isFetching;

  return (
    <>
      <Purchasemodal
        purchase={purchase}
        setPurchase={setPurchase}
        planselected={planselected}
        shopid={id}
        getbusinesstype={getbusinesstype}
      />
      <Container className="">
        <Row>
          <Modal
            size="xl"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header
              style={{ backgroundColor: "#0353A4" }}
              closeButton
            ></Modal.Header>
            <Modal.Body className="p-5 pb-2">
              {loading ? (
                <div className="d-flex justify-content-center align-items-center py-5">
                  <Spinner animation="border" style={{ color: "#0353A4" }} />
                </div>
              ) : isError ? (
                <Alert variant="danger" className="text-center">
                  Failed to load subscription plans. Please try again.
                  <div className="mt-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => refetch()}
                    >
                      Retry
                    </button>
                  </div>
                </Alert>
              ) : paymentplan.length === 0 ? (
                <Alert variant="info" className="text-center">
                  No subscription plans available at the moment.
                </Alert>
              ) : (
                <Row className="justify-content-center align-items-stretch">
                  {paymentplan.map((plan, index) => {
                    const price = formatPrice(plan);
                    const features = getPlanFeatures(plan);
                    return (
                      <Col
                        key={plan?._id || plan?.planName || index}
                        lg={4}
                        xl={4}
                        className="p-4"
                      >
                        <Card
                          className="cardsettingss h-100"
                          style={{ borderRadius: "20px" }}
                        >
                          <Card.Body className="d-flex flex-column">
                            <div className="text-end">
                              <button
                                type="button"
                                className="w-50 py-1"
                                style={{
                                  backgroundColor: "#003559",
                                  borderRadius: "15px",
                                  color: "white",
                                  border: "none",
                                }}
                              >
                                Monthly
                              </button>
                            </div>
                            <div className="ps-3 pe-3 flex-grow-1 d-flex flex-column">
                              <div className="mt-3">
                                <h3
                                  style={{
                                    color: "#0353A4",
                                    fontFamily: "monospace",
                                  }}
                                >
                                  {price.currency}{" "}
                                  {price.isFree ? "Free" : price.amountLabel}
                                </h3>
                                <h4 style={{ color: "#003559" }}>
                                  {plan?.planName || "Plan"}
                                </h4>
                                <span
                                  style={{
                                    color: "#0353A4",
                                    fontSize: "x-small",
                                  }}
                                >
                                  Marketing Plan
                                </span>
                              </div>
                              <div className="mt-3 flex-grow-1">
                                {features.length === 0 ? (
                                  <span
                                    className="text-muted"
                                    style={{ fontSize: "small" }}
                                  >
                                    No features listed for this plan.
                                  </span>
                                ) : (
                                  features.map((feature, idx) => (
                                    <div
                                      key={`${plan?._id || index}-f-${idx}`}
                                      className="d-flex align-items-start justify-content-start mb-1"
                                    >
                                      <CheckCircleIcon
                                        style={{
                                          color: "rgb(0, 53, 89)",
                                          width: "10%",
                                          flexShrink: 0,
                                        }}
                                      />
                                      <span
                                        className="ms-2"
                                        style={{
                                          color: "#0353A4",
                                          fontSize: "small",
                                          wordWrap: "break-word",
                                          maxWidth: "180px",
                                        }}
                                      >
                                        {feature?.title}
                                      </span>
                                    </div>
                                  ))
                                )}
                              </div>
                              <div className="mt-5 mb-3">
                                <button
                                  type="button"
                                  className="w-100 py-2 cursor_P"
                                  style={{
                                    backgroundColor: "#267DCF",
                                    borderRadius: "30px",
                                    color: "#FFFFFF",
                                    border: "none",
                                    fontSize: "small",
                                  }}
                                  onClick={() => {
                                    setPlanselected(plan);
                                    setPurchase(true);
                                    setLgShow(false);
                                  }}
                                >
                                  Subscribe
                                </button>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                  <div className="mt-5"></div>
                </Row>
              )}
            </Modal.Body>
          </Modal>
        </Row>
      </Container>
    </>
  );
};

export default Subscriptionmdl;
